const actionsScope = 'SURVEYS';

export const SURVEYS_TYPES = {
  LINK_CONSENT: `${actionsScope}/LINK_CONSENT`,
};

export const ASSIGNMENT_METHOD = {
  PROGRAM: 'program',
  PROVIDER: 'provider',
  BY_SYSTEM: 'admin',
  PRE_VISIT_FORM: 'pre_visit_form',
  REFERRAL_FORM: 'referral_form',
};



// WEBPACK FOOTER //
// ./src/redux/surveys/constants.js